export default {
  path: '/products',
  component: () => import('@/layouts/PublicLayout'),
  redirect: '/products/list',
  children: [
    {
      path: 'list',
      component: () => import('@/views/products/List'),
      meta: {
        title: '商品列表'
      }
    }
  ]
}
